<template>
  <div class="content-area" style="background-color: white;">
    <div id="bienvenidaSistema" class="d-flex justify-content-center align-items-center">
      <div id="secciondebienvenidasistema" class="d-flex flex-wrap align-items-center justify-content-center">
        <figure class="text-center">
          <img src="../../assets/paginaoficial/Logotipo_Positivo_Horizontal.png" alt="Logo de Poder Judicial del Estado de Aguascalientes" />
        </figure>
        <h2>BIENVENIDOS AL SISTEMA DE {{Sistema}}</h2>
        <h4></h4>
      </div>
    </div>
  </div>
</template>

<script>
  import comun from '@/../static/js/comun'

  export default {
    props:
    {
      Sistema: ''
    }
  }
</script>

<style scoped>
  #secciondebienvenidasistema {
    width: 40vw;
    height: 600px;
    align-content: center;
  }

  h2 {
    margin-top: 3vh;
    text-align: center;
    color: var(--gris-pj);
  }

  h4 {
    margin-top:1vh;
  }

  @media (max-width: 991px) {
    h2 {
      font-size: .9rem;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Tablero/BienvenidaSistemas.vue